import { waitForElementToExist, onRemove } from './waitForElement';
import { iconTrash } from '../components/iconTrash';
import { iconCart } from '../components/iconCart';
import { textureCart } from '../components/textureCart';
import { callOutsStyle } from './callOut';

/* eslint-disable */
const pageStyle = ({ page }) => {
	/* title */
	const container = page.querySelector('.c7-cart__content');
	if (!container) return;
	container.classList = `page-container flex flex-col lg:flex-row`;

	const main = container.closest('main');
	const bgImage = document.createElement('img')
	/* image background */
	bgImage.src = template.texture_default;
	bgImage.classList = 'absolute inset-0 object-cover object-top w-full h-full mix-blend-multiply opacity-20'
	main.classList += ' relative bg-[#FBF9F0]'
	main.appendChild(bgImage)
}
const titleStyle = ({ page }) => {
	/* title */
	const titleH1 = page.querySelector('.c7-h1');
	if (!titleH1) return;
	titleH1.classList = `text-2xl font-bold uppercase headlines-font md:text-3xl lg:text-4xl xl:text-5xl text-center headline-title gap-4 text-brown mb-8`;
}

const productListStyle = async ({ page }) => {
	const listItemsContainer = page.querySelector('.c7-order-items ul');
	if (!listItemsContainer) return { ok: false };
	const listItems = listItemsContainer.querySelectorAll('li');

	/* background & spacing */
	listItemsContainer.parentElement.classList += ' bg-[#FFFDF5] px-8 py-8'
	listItemsContainer.style = "gap: .5rem;"

	/* table headboard */
	listItemsContainer.insertAdjacentHTML('afterbegin', `<li class="hidden 2lg:flex gap-4 text-[#484A47] opacity-60 font-bold text-sm mb-4">
		<span class="flex-[0_0_120px]">Item</span>
		<span class="flex-1"></span>
		<span class="ml-auto min-w-[95px] text-center">Price</span>
		<span class="min-w-[95px] text-center">Quantity</span>
		<span class="min-w-[95px] text-center">SubTotal</span>
	</li> `);

	/* items in cart */
	listItems.forEach((item) => {
		item.classList = 'flex flex-col 2lg:flex-row gap-4 border-t border-[#EAEAEA] py-4';
		const itemImage = item.querySelector('.c7-order-item__image');
		itemImage.classList = 'flex-[0_0_120px] flex justify-center items-center max-w-[120px] max-h-[120px]';
		itemImage.querySelector('img').classList = 'aspect-square w-full h-full object-contain';

		const itemPricing = item.querySelector('.c7-order-item__pricing');
		const childPricing = itemPricing.children;
		itemPricing.classList = 'text-left grid 2lg:grid-cols-[repeat(3,minmax(0,100px))] gap-2 monospace-font font-bold text-xl 2lg:text-center [&_input]:text-center [&_select]:text-center [&_select]:rounded-full [&_button]:uppercase [&_button]:mt-2 [&_button]:text-base';
		const spanText = ['Price', 'Quantity', 'SubTotal'];
		Array.from(childPricing).forEach((child) => {
			child.classList = 'pt-[5px] first-of-type:pt-4 last-of-type:pt-4';
			child.insertAdjacentHTML('afterbegin', `<span class="text-sm text-[#484A47] mr-3 opacity-60 2lg:sr-only">${spanText[Array.from(childPricing).indexOf(child)]}</span>`);
		});

		const itemTitle = item.querySelector('.c7-order-item__title');
		itemTitle.classList = 'headlines-font font-semibold text-xl text-brown uppercase';

		const itemDesc = item.querySelector('.c7-order-item__description');
		itemDesc.classList = 'text-base text-brown uppercase mt-1 font-bold';

		/* item remove */
		const itemRemove = item.querySelector('button.c7-link');
		itemRemove.classList.add('flex', 'items-center', 'gap-2', 'uppercase', 'text-[#7B5D27]', 'font-bold', 'translate-y-2')
		itemRemove.insertAdjacentHTML('afterbegin', iconTrash({ props: 'class="w-4 h-4 stroke-0 stroke-[#7B5D27]"' }));
	})

	return { ok: true };
}

const buttonStyle = ({ target, addBg = false, mobile = false }) => {
	const buttonCheckout = target.querySelector('a.c7-btn');
	if (!buttonCheckout) return;
	const button = buttonCheckout.cloneNode(true);
	buttonCheckout.style = 'display:none;';
	const buttonCheckoutContainer = document.createElement('div');
	buttonCheckoutContainer.classList = 'button-container flex justify-center px-6 py-6';
	addBg && (buttonCheckoutContainer.classList += ' bg-[#363535]');
	mobile && (buttonCheckoutContainer.classList += ' 2lg:hidden');
	buttonCheckoutContainer.appendChild(button);
	target.appendChild(buttonCheckoutContainer);
	button.classList = 'button button-solid bg-yellow-light text-brown uppercase font-bold border-0 hover:no-underline hover:[color:#fff!important;] hover:[text-decoration:none!important;]';
}

const couponStyle = ({ target }) => {
	const couponArea = target.querySelector('.c7-form--coupon-code-container');
	if (!couponArea) return;
	const trigger = couponArea.querySelector('.c7-link');
	trigger.innerHTML = 'Do you have a coupon code?';
	trigger.classList = 'text-brown no-underline mb-4';

	const inputText = couponArea.querySelector('input[name="couponCode"]');
	inputText.style = 'border: 0; margin: 0; background: none; box-shadow: none;';
	inputText.classList = 'focus:outline-none focus:ring-0 focus:border-transparent';

	const inputGroup = couponArea.querySelector('.c7-form__group');
	inputGroup.style = '--c7-button-border-radius:25px;';
	inputGroup.classList = 'bg-[#F0EFE7] p-0.5 rounded-3xl flex [&_.c7-btn]:button [&_.c7-btn]:button-solid [&_.c7-btn]:bg-yellow [&_.c7-btn]:text-white [&_.c7-btn]:uppercase [&_.c7-btn]:font-bold [&_.c7-btn]:border-0 [&_.c7-btn]:hover:no-underline [&_.c7-btn]:hover:[color:#fff!important;] [&_.c7-btn]:hover:[text-decoration:none!important;] [&_.c7-btn]:px-5';
}

const orderSummaryStyle = ({ page }) => {
	const orderSummary = page.querySelector('.c7-cart__summary-container') || page.querySelector('.c7-side-cart__summary-container');
	if (!orderSummary) return;
	orderSummary.classList += ' bg-[#FFFDF5] pt-8 relative lg:ml-4 lg:self-start';

	const order = orderSummary.querySelector('.c7-order-summary')
	order && (order.classList = 'z-10 relative flex flex-col [&_>div]:px-6 [&_.c7-h2]:px-6 text-sm');

	const orderTotals = orderSummary.querySelectorAll('.c7-order-summary__item--total');
	const orderTotalsLast = orderTotals[orderTotals.length - 1];
	orderTotalsLast.classList += ' px-6 bg-[#363535] border-t-0 text-white text-xl font-semibold relative mt-14 order-1';
	orderTotalsLast.insertAdjacentHTML('beforeend', textureCart({ props: `class="absolute top-0 left-0 -translate-y-10" style="width: 100%; height: auto; stroke: none; stroke-width: 0;"` }));

	const orderDiscount = orderSummary.querySelector('.c7-order-summary__discount');
	orderDiscount && (orderDiscount.classList += ' text-xs mt-3');
	orderDiscount && orderDiscount.querySelector('svg').remove();

	buttonStyle({ target: orderSummary, addBg: true });
	buttonStyle({ target: page.querySelector('.c7-cart__header'), mobile: true });
	couponStyle({ target: orderSummary });
}

const emptyCartStyle = ({ page, container, hideCounter = false }) => {
	// styles for empty cart
	const emptyCart = container || page.querySelector('.page-container');
	const infoContainer = !container && page.querySelector('.info-container');
	infoContainer && infoContainer.classList.remove('mt-6');
	const emptyContainer = emptyCart.querySelector('.c7-notice--empty');
	emptyContainer && (emptyContainer.style = 'margin: 0;');
	emptyCart.classList = 'c7-side-cart__content-container page-container flex flex-col place-items-center py-12';
	!hideCounter && (emptyCart.classList += ' bg-[#FFFDF5]');
	hideCounter && (emptyCart.classList += ' bg-[#F0EFE7]');
	buttonStyle({ target: emptyCart });

	emptyContainer && (emptyContainer.innerHTML = /* html */`
		${iconCart({ props: 'class="mb-6 mx-auto" style="width: auto; height: auto; stroke: none; stroke-width: 0;"', hideCounter })}
		<h2 class="text-brown font-bold text-2xl mb-4">Your cart is empty</h2>
		<p class="text-brown">Add your favorite wines to your cart.</p>
	`)
}

const sideCartStyle = ({ page }) => {
	page.style = 'background-color: #F0EFE7; color: black'
	const cartSideHeader = page.querySelector('.c7-side-cart__header');
	cartSideHeader.classList += ' bg-[#F0EFE7] uppercase'
	cartSideHeader.querySelector('h1').remove();
	cartSideHeader.insertAdjacentHTML('afterbegin', `
		<h2 class="text-brown font-bold text-2xl headlines-font">
			Your shopping cart
		</h2>
	`);
}

const productListSideCartStyle = async ({ page }) => {
	page.querySelector('.c7-side-cart__content-container').style = 'padding-bottom: 3rem;';
	const orderItems = page.querySelector('.c7-order-items');
	if (!orderItems) return { ok: false };
	orderItems.classList += ' w-full';
	const listItemsContainer = orderItems.querySelector('ul');
	if (!listItemsContainer) return { ok: false };
	listItemsContainer.classList += ' w-full list-items-side';
	const listItems = listItemsContainer.querySelectorAll('li');

	const titleSideCart = page.querySelector('.c7-side-cart__header h2');
	titleSideCart.innerHTML = listItemsContainer && `Your shopping cart (${listItems.length})`;

	const observer = new MutationObserver((mutationsList, observer) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList') {
				const listItems = listItemsContainer.querySelectorAll('li');
				titleSideCart.innerHTML = listItemsContainer && `Your shopping cart (${listItems.length})`;
			}
		}
	});

	observer.observe(listItemsContainer, { childList: true });

	return { ok: true };
}

const onResetSideCart = ({ page }) => {
	const titleSideCart = page.querySelector('.c7-side-cart__header h2');
	titleSideCart.innerHTML = 'Your shopping cart';
	// remove callouts
	const infoContainer = page.querySelector('.info-container');
	infoContainer && infoContainer.remove();

	// remove button-container
	const buttonContainer = page.querySelector('.button-container');
	buttonContainer && buttonContainer.remove();
}

const emptySideCartStyle = ({ page }) => {
	waitForElementToExist({
		selector: '.c7-notice--empty',
		targetDocument: page,
	}).then(() => {
		onResetSideCart({ page });
		emptyCartStyle({
			page,
			container: page.querySelector('.c7-side-cart__content-container'),
			hideCounter: true
		});
		callOutsStyle({ page, showHelp: false });

		// execute again to remove the button-container
		onRemove({ selector: '.c7-notice--empty', targetDocument: page }).then(() => {
			emptySideCartStyle({ page });

			onResetSideCart({ page });
		})
	});
}

const orderSummarySideCartStyle = ({ page }) => {
	const orderSummary = page.querySelector('.c7-side-cart__summary-container');
	if (!orderSummary) return;
	orderSummary.classList += ' bg-[#363535] pt-8 relative px-0';

	const order = orderSummary.querySelector('.c7-order-summary')
	order && (order.classList = 'z-10 relative flex flex-col [&_.c7-h2]:px-6 text-sm text-[#E6E4D1]');

	const orderSubTotal = orderSummary.querySelector('.c7-order-summary__item--subtotal');
	orderSubTotal.classList += ' px-8 relative';
	orderSubTotal.insertAdjacentHTML('beforeend', textureCart({ props: `class="absolute top-0 left-0 -translate-y-14 -z-10" style="width: 100%; height: auto; stroke: none; stroke-width: 0;"` }));

	const orderTotals = orderSummary.querySelectorAll('.c7-order-summary__item--total');
	orderTotals && orderTotals.forEach((total) => {
		total.classList += ' mx-8 relative border-t border-[#F0EFE7]/10';
	});
	orderTotals && (orderTotals[orderTotals.length - 1].classList += ' text-xl font-semibold order-1');
	
	const otherItems = orderSummary.querySelectorAll('.c7-order-summary__item');
	otherItems && otherItems.forEach((item) => {
		item.classList += ' pt-[10px] mt-[10px] lg:pt-[15px] lg:mt-[15px] mx-8 relative border-t border-[#F0EFE7]/10';
	});

	const orderDiscountStyle = () => {
		waitForElementToExist({ selector: '.c7-order-summary__discount', targetDocument: orderSummary }).then(() => {
			const orderDiscount = orderSummary.querySelector('.c7-order-summary__discounts');
			const discounts = orderDiscount.querySelectorAll('.c7-order-summary__discount');
			discounts && discounts.forEach((discount) => {
				discount.classList += ' mx-8 relative border-t border-[#F0EFE7]/10 pt-[10px] mt-[10px] lg:pt-[15px] lg:mt-[15px]';
				discount.querySelector('svg').remove();
			});

			onRemove({ selector: '.c7-order-summary__discount', targetDocument: orderSummary }).then(() => {
				orderDiscountStyle();
			});
		});
	}
	orderDiscountStyle();

	const buttonsContainer = orderSummary.querySelector('.c7-order-summary__buttons');
	buttonsContainer && (buttonsContainer.classList += ' flex flex-row md:flex-wrap gap-4 px-1 lg:px-8 order-2');
	const stylesButtons = {
		0: {
			"class": "px-2 lg:px-6 text-sm lg:text-base button button-outline text-white font-medium",
			"textContent": "View cart"
		},
		1: {
			"class": "px-2 lg:px-6 text-sm lg:text-base button button-solid bg-yellow text-[#473D21] font-medium",
			"textContent": "Checkout"
		}
	}
	const buttons = buttonsContainer.querySelectorAll('.c7-btn');
	buttons && buttons.forEach((button, index) => {
		button.classList = stylesButtons[index].class;
		button.textContent = stylesButtons[index].textContent;
	})
}

const emptySideCartListStyle = ({ cartSide7 }) => {
	waitForElementToExist({
		selector: '.c7-order-items ul',
		targetDocument: cartSide7
	}).then(() => {
		productListSideCartStyle({ page: cartSide7 }).then((response) => {
			if (!response.ok) {
				throw new Error('No listItemsContainer');
			}
			orderSummarySideCartStyle({ page: cartSide7 });
		})

		onRemove({ selector: '.c7-order-items ul', targetDocument: cartSide7 }).then(() => {
			emptySideCartListStyle({ cartSide7 });
		})
	})
}

export const cartPage = async () => {
	/* page cart */
	waitForElementToExist({ selector: 'article #c7-content .c7-cart' }).then(() => {
		const cart7 = document.querySelector('.site-main article #c7-content .c7-cart');
		pageStyle({ page: cart7 });
		titleStyle({ page: cart7 });
		callOutsStyle({ page: cart7 });

		productListStyle({ page: cart7 }).then((response) => {
			if (!response.ok) {
				throw new Error('No listItemsContainer')
			}
			orderSummaryStyle({ page: cart7 });
			waitForElementToExist({ selector: '.c7-notice--empty', targetDocument: cart7 }).then(() => {
				emptyCartStyle({ page: cart7 });
			})
		}).catch((error) => {
			emptyCartStyle({ page: cart7 });
		});
	})

	/* side cart */
	waitForElementToExist({ selector: '#c7-cart .c7-side-cart' }).then(() => {
		const cartSide7 = document.querySelector('#c7-cart .c7-side-cart');
		/* base styles */
		sideCartStyle({ page: cartSide7 });

		/* wait for changes in the list */
		emptySideCartListStyle({ cartSide7 });
		emptySideCartStyle({ page: cartSide7 });

		// Create an observer for changes to the class attribute
		const observer = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					if (cartSide7.classList.contains('c7-side-cart--visible')) {
						// c7-side-cart--visible class addedd
						const backdropDiv = document.createElement('div');
						document.querySelector('body').style = 'overflow: hidden;';
						document.querySelector('.c7-side-cart').style = 'overflow: hidden;';
						backdropDiv.classList = 'fixed inset-0 bg-black/50 z-50 backdrop-cart backdrop-blur-sm';
						document.body.appendChild(backdropDiv);
					} else {
						// c7-side-cart--visible class removed
						const backdropDiv = document.querySelector('.backdrop-cart');
						backdropDiv && backdropDiv.remove();
						document.querySelector('body').style = '';
					}
				}
			}
		});

		// Create an observer for changes to the list
		observer.observe(cartSide7, { attributes: true });

	});
}